import {
	TabbedForm,
	FormTab,
	ReferenceInput,
	SelectInput,
	TextInput,
	ImageInput,
	ImageField,
	SimpleFormIterator,
	NumberInput,
	NullableBooleanInput,
	ArrayInput
} from "react-admin";
import { TimeInput } from "react-admin-date-inputs";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import thLocale from "date-fns/locale/th";
import React from "react";

import { required, isBool, minValue } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";
import { typeRoomService } from "../../constant/TypeRoomService";

const FacilitiesForm = props => {
	const { record } = props;
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
	return (
		<TabbedForm {...props}>
			<FormTab label="facilities.tab.general">
				<ReferenceInput
					disabled={record.project ? true : false}
					validate={[required()]}
					source="project"
					reference="project"
					filter={filter}
				>
					<SelectInput optionText="name" />
				</ReferenceInput>
				<SelectInput
					source="type"
					defaultValue={1}
					validate={[required()]}
					choices={typeRoomService}
				/>
				<TextInput source="name" label="ชื่อภาษาไทย" validate={[required()]} />
				<TextInput source="name_en" label="ชื่อภาษาอังกฤษ" validate={[required()]} />
				<TextInput source="name_jp" label="ชื่อภาษาญี่ปุ่น" validate={[required()]} />
				<TextInput source="name_zh" label="ชื่อภาษาจีน" validate={[required()]} />
				<SelectInput
					source="time"
					choices={[{ id: 30, name: "30 นาที" }, { id: 60, name: "60 นาที" }]}
				/>
				<TimeInput
					source="open"
					validate={[required()]}
					label="เวลาเปิด"
					options={{ format: "HH:mm" }}
					providerOptions={{ utils: MomentUtils, locale: thLocale }}
				/>
				<TimeInput
					source="close"
					validate={[required()]}
					label="เวลาปิด"
					options={{ format: "HH:mm" }}
					providerOptions={{ utils: MomentUtils, locale: thLocale }}
				/>
				<ImageInput
					multiple={false}
					validate={[required()]}
					source="image"
					accept="image/*"
				>
					<ImageField source="url" title="title" />
				</ImageInput>
			</FormTab>
			<FormTab label="facilities.tab.booking">
				<NullableBooleanInput
					validate={[isBool()]}
					style={{ width: 300 }}
					source="booking"
				/>
				<ArrayInput source="notification_emails" label="ส่งอีเมลเมื่อมีการจองสิ่งอำนวยความสะดวกไปที่" fullWidth>
					<SimpleFormIterator>
						<TextInput label="Email Address" source="email" type="email" validate={[required()]}/>
					</SimpleFormIterator>
				</ArrayInput>
				<NumberInput
					defaultValue={3}
					validate={[minValue(0)]}
					fullWidth
					source="booking_future_day"
				/>
				<NumberInput
					defaultValue={3}
					validate={[minValue(0)]}
					fullWidth
					source="booking_user_perday"
				/>
				<NumberInput
					defaultValue={1}
					validate={[minValue(0)]}
					fullWidth
					source="booking_slot_pertime"
				/>
			</FormTab>
		</TabbedForm>
	);
};

export default FacilitiesForm;



// WEBPACK FOOTER //
// ./src/components/facilities/FacilitiesForm.js